/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@/redux/store';
import { cabinetShape, defaultSize } from '@/utils/rules/const';
import AidRect from './aidRectCheckbox.module.scss';
import rectCheckboxContext from '../../utils/rectCheckboxContext';
import TestPng from '../../assets/test.png';

function AidRectCheckbox(props) {
  const { t } = useTranslation();

  const {
    icon, index, text, checked, style, unit, onChange, isTop,
  } = props;

  const {
    width, height, fontSize = '14', marginRight, marginTop,
  } = style;

  const {
    typeI, typeH, typeL, typeU,
  } = cabinetShape;

  const containerHeight = height || width;
  const context = React.useContext(rectCheckboxContext);
  const {
    dispatch, initState, initState: {
      isChangeTopTips, featLeft, isSeat, sizeUnder, sizeTop, lengthTopVal, lengthVal,
    },
  } = useContext(AppContext);
  const [bothSide, setBothSide] = useState(false);
  const sideArray = [
    {
      id: 0,
      name: t('other.left'),
      left: '0',
      key: 'L',
    }, {
      id: 1,
      name: t('other.middle'),
      left: '33%',
      key: 'M',
    }, {
      id: 2,
      name: t('other.right'),
      left: '66%',
      key: 'R',
    },
  ];
  const [sideList, setSideList] = useState(sideArray);

  const changeSide = (key) => {
    if (!isTop) return;
    if (key) {
      switch (key) {
        case 'L':
          dispatch({ type: 'featLeft', payload: '0' });
          break;
        case 'M':
          dispatch({ type: 'featLeft', payload: '33%' });
          // I型顶柜在中间，长度不能大于U型底柜的L2
          if (sizeUnder.key === typeU && sizeTop.key === typeI
             && (lengthTopVal[1] ? lengthTopVal[1] : lengthTopVal.filter((n) => n)[0]) > lengthVal[1]) {
            dispatch({
              type: 'setTopLength',
              payload: [
                defaultSize.U?.top?.len1,
                defaultSize.U?.top?.len2,
                defaultSize.U?.top?.len3,
              ],
            });
          }
          break;
        case 'R':
          if (sizeUnder.key === typeU && sizeTop.key === typeI) {
            dispatch({ type: 'featLeft', payload: '66%' });
          } else {
            dispatch({ type: 'featLeft', payload: '50%' });
          }
          break;
        default:
          break;
      }
    } else {
      Object.keys(sideList).forEach((i) => {
        if (isSeat === sideList[sideList.length - 1].key) {
          dispatch({ type: 'isSeat', payload: 'L' });
          dispatch({ type: 'featLeft', payload: '0' });
        } else if (isSeat === sideList[i].key) {
          dispatch({ type: 'isSeat', payload: sideList[+i + 1].key });
          // U型底柜I型顶柜，在中间，顶柜长度大于L2，初始化长度
          if (sideList[+i + 1].key === 'M' && sizeUnder.key === typeU && sizeTop.key === typeI
          && (lengthTopVal[1] ? lengthTopVal[1] : lengthTopVal.filter((n) => n)[0]) > lengthVal[1]) {
            dispatch({
              type: 'setTopLength',
              payload: [
                defaultSize.U?.top?.len1,
                defaultSize.U?.top?.len2,
                defaultSize.U?.top?.len3,
              ],
            });
          }
          if (sizeUnder.key === typeU && sizeTop.key === typeI) {
            dispatch({ type: 'featLeft', payload: sideList[+i + 1].left });
          } else {
            dispatch({ type: 'featLeft', payload: '50%' });
          }
        }
      });
      dispatch({ type: 'isChangeTopTips', payload: false }); // 隐藏顶柜tips
      dispatch({ type: 'isChangeApi', payload: true }); // 修改时切换柜型，调用接口init/update
    }
  };
  useEffect(() => {
    setBothSide(false);
    setSideList(sideArray.slice(0, 1).concat(sideArray.slice(2, sideArray.length)));
    if (sizeUnder.key === typeL && sizeTop.key === typeI) {
      setBothSide(true);
    }
    if (sizeUnder.key === typeH && sizeTop.key === typeI) {
      setBothSide(true);
    }
    if (sizeUnder.key === typeU && sizeTop.key === typeI) {
      setSideList(sideArray);
      setBothSide(true);
    }
    if (sizeUnder.key === typeU && sizeTop.key === typeL) {
      setBothSide(true);
    }
    changeSide(isSeat);
  }, [sizeUnder.key, sizeTop.key]);

  return (
    <div
      role="button"
      tabIndex="0"
      className={`${checked ? AidRect['aid-bc-checked'] : AidRect['aid-bc-unchecked']} ${AidRect['aid-bc-container']}`}
      style={{
        width: `${width}${unit}`,
        height: `${containerHeight}${unit}`,
        marginRight: `${marginRight}${unit}`,
        marginTop: `${marginTop}${unit}`,
      }}
      onClick={
        () => {
          changeSide();
          onChange(index); if (context.onChange) { context.onChange(index); }
        }
      }
      aria-hidden
    >
      <div
        style={
          {
            width: `${width}${unit}`,
            top: `${width / 4.57}${unit}`,
          }
        }
        className={AidRect['aid-icon-container']}
      >
        {icon}
      </div>
      <span
        className={AidRect['checkbox-text']}
        style={{ bottom: `${height / 7}${unit}`, fontSize: `${fontSize}` }}
      >
        {text}
      </span>
      {
        checked && bothSide && isTop ? ( // 选中，需要更换的柜型，顶柜
          <div className={AidRect['aid-side-back']}>
            {
              sideList.map((item, index) => (
                <div
                  // role="none"
                  // onClick={() => changeSide(item.key)}
                  className={`${AidRect['side-name']}`}
                  key={item.id}
                >
                  <span style={{
                    left: sideList[index].left,
                    color: isSeat === item.key ? '#000' : '',
                  }}
                  >
                    {item.name}
                  </span>
                </div>
              ))
            }
            {
              isChangeTopTips ? <div className={AidRect['side-tip-back']}>{t('other.change_type')}</div> : null
            }
            <div
              className={AidRect['side-check']}
              style={{
                left: featLeft,
                width: sideList.length === 2 ? '50%' : '33%',
              }}
            />

          </div>
        ) : null
      }

    </div>
  );
}

AidRectCheckbox.propTypes = {
  icon: PropTypes.element,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  index: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object]),
  unit: PropTypes.string,
  isTop: PropTypes.bool,
};
AidRectCheckbox.defaultProps = {
  icon: (<img alt="" src={TestPng} />),
  checked: false,
  onChange: () => {},
  index: '',
  text: '',
  style: {},
  unit: 'rem',
  isTop: false,
};

export default AidRectCheckbox;
